import createSvgIcon from '../Utils/CreateSvgIcon';

export const ChevronDown = createSvgIcon(
  <path
    clipRule="evenodd"
    d="M12.0711 14.7279L5.70718 8.36392L4.29297 9.77814L12.0711 17.5563L19.8493 9.77814L18.4351 8.36392L12.0711 14.7279Z"
    fillRule="evenodd"
  />,
  'ChevronDown',
);
